export interface PatentLegalStatusService {
    /**
     * 获取专利法律状态
     */
    getPatentLegalStatus(): Promise<any>;
}

export const PatentLegalStatusService = Symbol.for('PatentLegalStatusService');
